import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";
import { useTheme } from "../../context/ThemeContext";

function Github() {
  const { theme } = useTheme();

  const labelColor =
    theme === "light"
      ? "#334155"
      : theme === "clay"
      ? "#4a3860"
      : undefined; // dark/purple: let library default handle it

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
        Days I <strong className="purple">Code</strong>
      </h1>
      <div style={{ display: "flex", justifyContent: "center", ...(labelColor ? { color: labelColor } : {}) }}>
        <GitHubCalendar
          username="NgocTien0110"
          blockSize={15}
          blockMargin={5}
          color="#c084f5"
          fontSize={16}
        />
      </div>
    </Row>
  );
}

export default Github;
